export default __webpack_public_path__ + "static/media/img-0785-portugal-full-face.5d132b3c.png";